;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';

import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import EntryLink from 'components/ui/Link/EntryLink';
import { getAccessibleEntryLinkLabel } from 'components/ui/RichText/defaults';
import Text from 'components/ui/Text';

import styles from './Ingredients.module.scss';

export const overrides = {
    renderNode: {
        [INLINES.ENTRY_HYPERLINK]: node => {
            return (
                <EntryLink
                    entry={node?.data?.target}
                    className={styles.link}
                    aria-label={getAccessibleEntryLinkLabel(
                        node.content,
                        node?.data?.target
                    )}
                >
                    {node.content[0].value}
                </EntryLink>
            );
        },
        [BLOCKS.HEADING_4]: (node, children) => {
            return (
                <Text
                    as="h4"
                    baseTheme="labelMedium"
                    className={styles.heading}
                >
                    {children}
                </Text>
            );
        },

        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    baseTheme="bodyMedium"
                    className={styles.paragraph}
                >
                    {children}
                </Text>
            );
        },
        [BLOCKS.UL_LIST]: (node, children) => {
            const isNested = node.content.map(item =>
                item.content.some(list => list.nodeType === 'unordered-list')
            )[0];
            return (
                <ul
                    className={cx(styles.list, {
                        [styles.nestedList]: isNested,
                    })}
                >
                    {children}
                </ul>
            );
        },
        [BLOCKS.OL_LIST]: (node, children) => {
            return <ol className={styles.list}>{children}</ol>;
        },
        [BLOCKS.LIST_ITEM]: (node, children) => {
            return (
                <li itemProp="ingredients" className={styles.listItem}>
                    {children}
                </li>
            );
        },
    },
    renderText: text => {
        const isFraction = /(?:[1-9][0-9]*|0)\/[1-9][0-9]*/g;
        const startsWithNumber = /^[0-9].*/g;

        // Do we have the number to start
        if (text && text.match(startsWithNumber)) {
            // true fraction
            if (text.match(isFraction)) {
                let pieces = text.split(' ');

                return (
                    <span>
                        {pieces.map((piece, idx) => {
                            if (piece.match(isFraction)) {
                                const frac = piece.replace(/\*+/g, '');
                                const split = frac.split('/');

                                return (
                                    <span className={styles.fraction} key={idx}>
                                        <sup>{split[0]}</sup>
                                        &frasl;
                                        <sub>{split[1]}</sub>
                                    </span>
                                );
                            }

                            return `${piece} `;
                        })}
                    </span>
                );
            }

            // ligature
            return text.replace(/\*+/g, '');
        }

        return text;
    },
};
